import { BaseModel } from "sjs-base-model";
import SubscriptionDateRangesModel from "./SubscriptionDateRangesModel";

// Returned Api Data sample
// const example = {
//     subscriptionName: "EUREX-EOBI",
//     subscriptionDescription: "Eurex EOBI",
//     dateRanges: {
//         unrestricted: false,
//         ranges: [
//             {
//                 id: 1,
//                 startDate: 20210809,
//                 endDate: 20210903
//             }
//         ]
//     }
// };

export default class UserDateRangeModel extends BaseModel {
    subscriptionTypeId = 0;
    subscriptionName = "";
    subscriptionDescription = "";
    subscriptionComment = "";
    subscriptionIsFilterable = false;
    dateRanges = SubscriptionDateRangesModel;

    constructor(data) {
        super();
        this.update(data);
    }
}
